import Base, { defineAttributes } from './base'
import currentTimestamp from '/lib/current-timestamp'

function statusExpires(status) {
  return status === 'closed'
}

class Visitor extends Base {
  constructor(attributes) {
    super(attributes)
    if (!this.timesOnWidgets) {
      this.timesOnWidgets = {}
    }
  }

  get modelName() {
    return 'visitor'
  }

  get status() {
    let timestamp = currentTimestamp()
    if (this.statusObject) {
      if (!this.statusObject.expiresAt || this.statusObject.expiresAt > timestamp) {
        return this.statusObject.value
      } else if (this.statusObject.value === 'closed') {
        return 'closedPopup'
      }
    }
  }

  set status(value) {
    this.statusObject = {
      value: value,
      expiresAt: statusExpires(value) ? currentTimestamp() + 60 * 60 : null,
    }
  }
}

defineAttributes(Visitor, ['statusObject', 'timesOnWidgets', 'currentCallId', 'currentCallStatus', 'currentCallFilterId', 'referrer'])

export default Visitor
